import ActiveIndicator from "@app/components/active-indicator.tsx";
import { EntryModel } from "@app/data/engine.ts";
import { formatUsd } from "@app/helpers/money-helper.ts";
import { commaSeperate } from "@app/helpers/number-helper.ts";
import { formatDate } from "@app/helpers/time-helper";
import { Checkbox } from "@mui/material";
import { createColumnHelper } from "bi-lib";

interface Props {
    allSelected: boolean;
    onSelectAll: () => void;
    onSelect: (id: string) => void;
    selectedItems: string[];
    quantityTotal: number;
    billAmountTotal: number;
    rowCount: number;
}

const columnHelper = createColumnHelper<EntryModel>();
export const invoicePotentialItemsTableDefinition = ({
    allSelected,
    onSelectAll,
    onSelect,
    selectedItems,
    quantityTotal,
    billAmountTotal,
    rowCount,
}: Props) => [
    columnHelper.display({
        id: "selections",
        header: () => <Checkbox color={"primary"} checked={allSelected} onChange={onSelectAll} />,
        cell: (item) => (
            <Checkbox
                checked={selectedItems.includes(item.row.original.entryId!)}
                onChange={() => onSelect(item.row.original.entryId!)}
            />
        ),
        footer: () => `${rowCount} Rows`,
    }),
    columnHelper.accessor((x) => x.itemDate, {
        id: "itemDate",
        header: "Date",
        cell: (item) => formatDate(item.getValue()),
    }),
    columnHelper.accessor((x) => x.subcategory, { id: "subcategory", header: "Subcategory" }),
    columnHelper.accessor((x) => x.staffName, { id: "staffName", header: "Staff" }),
    columnHelper.accessor((x) => x.workPackageCode, { id: "workPackageCode", header: "WP Code" }),
    columnHelper.accessor((x) => x.taskCode, { id: "taskCode", header: "Task Code" }),
    columnHelper.accessor((x) => x.quantity, {
        id: "quantity",
        header: "Quantity",
        cell: (item) => commaSeperate(item.getValue()),
        footer: () => commaSeperate(quantityTotal),
        alignment: "right",
    }),
    columnHelper.accessor((x) => x.billingRate, {
        id: "billingRate",
        header: "Bill Rate",
        cell: (item) => formatUsd(item.getValue()),
        alignment: "right",
    }),
    columnHelper.accessor((x) => x.billingAmount, {
        id: "billingAmount",
        header: "Bill Amount",
        cell: (item) => formatUsd(item.getValue()),
        footer: () => formatUsd(billAmountTotal),
        alignment: "right",
    }),
    columnHelper.accessor((x) => x.isBillable, {
        id: "isBillable",
        header: "Billable",
        cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
    }),
    columnHelper.accessor((x) => x.isInvoiceVisible, {
        id: "isInvoiceVisible",
        header: "Invoice Visible",
        cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
    }),
    columnHelper.accessor((x) => x.isReimbursable, {
        id: "isReimbursable",
        header: "Reimbursable",
        cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
    }),
    columnHelper.accessor((x) => x.isPosted, {
        id: "isPosted",
        header: "Posted",
        cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
    }),
    columnHelper.accessor((x) => x.description, { id: "description", header: "Description" }),
];
